import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Page from './Page'
import Spinner from '../Spinner/Spinner'
import Alert from '../Alert/Alert'

const Posts = () => {
	const [loading, setLoading] = useState(false)
	const [posts, setPosts] = useState([])

	useEffect(() => {
		setLoading(true)
		fetch('https://cp-node-api.herokuapp.com/api/posts')
			.then((res) => res.json())
			.then((data) => [setPosts(data), setLoading(false)])
	}, [])

	const token = JSON.parse(localStorage.getItem('user'))

	const handleDelete = (id) => {
		fetch(`https://cp-node-api.herokuapp.com/api/posts/${id}`, {
			method: 'DELETE',
			headers: {
				token: `Bearer ${token.accessToken}`,
				'Content-Type': 'application/json',
			},
		})
			.then((res) => res.json())
			.then((data) => {
				let newPosts = posts.filter((post) => post._id !== data._id)
				setPosts(newPosts)
			})
	}

	return (
		<Page>
			<Link to='/posts/add-new' className='btn btn-primary mb-3'>
				Add New Post
			</Link>
			{loading ? (
				<Spinner />
			) : (
				<table className='table table-striped table-hover table-responsive w-50'>
					{posts.length > 0 && (
						<thead>
							<tr>
								<th scope='col'>#</th>
								<th scope='col'>Title</th>
								<th scope='col'>Created At</th>
								<th scope='col'></th>
								<th scope='col'></th>
							</tr>
						</thead>
					)}
					<tbody>
						{posts.length > 0 ? (
							posts.map((post, i) => (
								<tr key={post._id}>
									<th scope='row'>{i + 1}</th>
									<td>{post.title}</td>
									<td>{post.createdAt}</td>
									<td>
										<Link
											to={`/posts/edit/${post._id}`}
											className='btn btn-secondary me-3'
										>
											Edit
										</Link>
										<button
											onClick={() =>
												handleDelete(post._id)
											}
											className='btn btn-danger'
										>
											Delete
										</button>
									</td>
								</tr>
							))
						) : (
							<Alert msg='No posts found' />
						)}
					</tbody>
				</table>
			)}
		</Page>
	)
}

export default Posts
